<template>
  <v-row v-if="allowed">
    <v-col>
      <div v-for="(element, index) in lists.data" :key="element" :id="element.id">
        <div class="chart-container" style="position: relative;" :style="`width: ${size.width}; height: ${size.height};`">
          <canvas :class="uuid" :id="uuid+'_'+index" :style="`width: ${size.width}; height: ${size.height};`" />
        </div>
      </div>
    </v-col>
    <v-col cols="3">
      <div :id="uuid+'_legend'" style="max-width: 300px">
        <div v-for="(element, index) in types" :key="element" class="mb-1">
          <v-avatar :color="palette[index]" size="30">
            <span style="font-size: 10px; z-index: 2; font-weight: bold;" :style="`color: ${Colorize(palette[index])}`">{{ element.split(' - ')[0] }}</span>
          </v-avatar>
          <span style="margin-left: -3px; padding-left: 10px; z-index: 1" :style="`border-bottom: 1px solid ${palette[index]}`">{{ element.split(' - ')[1] }}</span>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Colorize, palette } from "@/libs/colorizer";
import { Chart } from "chart.js/auto";

export default {
  name: "cb6fc894-1449-11eb-8116-00155d01060e",
  props: ['chart', 'size', 'title', 'uuid'],
  watch: {
    report_data() {
      this.update_charts()
    }
  },
  data() {
    return {
      charts: [],
      allowed: false,
      range: {
        min: 0,
        max: 0,
        middle: 0
      },
      types: [],
      lists: {
        objects: [],
        data: [],
        maximums: {
          small: 0,
          big: 0
        }
      }
    }
  },
  beforeMount() {
    this.init_charts()
  },
  mounted() {
    this.create_charts()
  },
  computed: {
    palette() {
      return palette
    },
    report_data() {
      return this.chart.report_data
    }
  },
  methods: {
    Colorize,
    create_charts: function () {
      for (let [index, object] of this.lists.data.entries()) {
        this.create_chart(object, index)
      }
    },
    clear_data: function () {
      this.allowed = false
      this.range = {
        min: 0,
        max: 0,
        middle: 0
      }
      this.types = []
      this.lists = {
        objects: [],
        data: [],
        maximums: {
          small: 0,
          big: 0
        }
      }
    },
    update_charts: function () {
      this.clear_data()
      for (let chart of this.charts) {
        chart.destroy()
      }
      this.charts = []
      this.init_charts()
      setTimeout(() => {
        this.create_charts()
      }, 100)
    },
    getDatasets: function (object) {
      let datasets = []
      let index = 0
      object.works.forEach(work => {
        datasets.push({
          index: index,
          label: work.name,
          data: [work.count]
        })
        index++
      })
      return datasets
    },
    create_chart: function (object, pos) {
      let ctx = document.getElementById(this.uuid+'_'+pos).getContext('2d');
      let chart = new Chart(ctx, {
        plugins: [ChartDataLabels],
        type: 'bar',
        data: {
          labels: ['Кол-во обращений'],
          datasets: this.getDatasets(object),
        },
        options: {
          indexAxis: 'y',
          plugins: {
            title: {
              display: true,
              text: ' '+object.name,
              align: 'start',
              padding: {
                top: 0,
                bottom: 0
              }
            },
            datalabels: {
              color: function (value) {
                return Colorize(value.dataset.backgroundColor)
              },
              anchor: 'center',
              clamp: true,
              formatter: function (value) {
                if (value > 0) return Math.ceil(value)
                return null
              }
            },
            legend: {
              display: false,
              position: 'right',
              align: 'start'
            }
          },
          scales: {
            x: {
              ticks: {
                display: false,
                color: '#bebebe'
              },
              stacked: true,
              title: false,
              min: 0,
              max: object.isBig ? this.lists.maximums.big : this.lists.maximums.small
            },
            y: {
              stacked: true,
              ticks: {
                display: true
              },
              beginAtZero: true
            }
          }
        }
      })
      this.charts.push(chart)
    },
    init_charts: function () {
      // Формируем список подсистем и находим максимальное значение
      for (let element of this.chart.report_data) {
        if (element['ПодсистемаПРЕДСТАВЛЕНИЕ'] && !this.types.includes(element['ПодсистемаПРЕДСТАВЛЕНИЕ'])) {
          this.types.push(element['ПодсистемаПРЕДСТАВЛЕНИЕ'])
        }
        if (element['Неисправности'] > this.range.max) {
          this.range.max = element['Неисправности']
        }
      }
      // Находим минимальное значение
      this.range.min = this.range.max
      for (let element of this.chart.report_data) {
        if (element['Неисправности'] && element['Неисправности'] < this.range.min) {
          this.range.min = element['Неисправности']
        }
      }
      // Находим математическю середину между числами
      this.range.middle = Math.ceil((this.range.max + this.range.min)/2)

      // Формируем список объектов
      for (let element of this.chart.report_data) {
        if (!this.lists.objects.includes(element['ФизОбъектПРЕДСТАВЛЕНИЕ'])) {
          this.lists.objects.push(element['ФизОбъектПРЕДСТАВЛЕНИЕ'])
        }
      }

      // Формируем список данных по объектам
      for (let object of this.lists.objects) {
        let data = this.chart.report_data.filter(el => el['ФизОбъектПРЕДСТАВЛЕНИЕ'] === object)
        this.lists.data.push({
          id: 'cb6fc894-1449-11eb-8116-00155d01060e_'+this.chart.report_data.find(el => el['ФизОбъектПРЕДСТАВЛЕНИЕ'] === object)['ФизОбъект'],
          name: object,
          isBig: this.checkBiggity(data),
          works: this.generateTypes(data)
        })
      }

      // Добавляем индексы к сортированным данным
      for (let [index, data] of this.lists.data.entries()) {
        data.index = index
        data.isFirst = 0 === index ? true : false
        data.isLast = this.lists.data.length-1 === index ? true : false
      }
      // Находим 2 последних эелемента в большом и маленьком диапазонах
      let smalls = this.lists.data.filter(el => !el.isBig)
      let biggs = this.lists.data.filter(el => el.isBig)

      for (let [index, data] of smalls.entries()) {
        data.firstOfSection = 0=== index ? true : false
        data.lastOfSection = smalls.length-1 === index ? true : false
      }
      for (let [index, data] of biggs.entries()) {
        data.firstOfSection = 0 === index ? true : false
        data.lastOfSection = biggs.length-1 === index ? true : false
      }

      // Находим максимумы для 2 типов: "Большие" и "Небольшие"
      for (let element of this.lists.data) {
        if (!element.isBig) {
          let summ = 0
          element.works.forEach(el => summ += el.count)
          if (summ > this.lists.maximums.small) this.lists.maximums.small = Math.ceil(summ / 5) * 5
          if (summ > this.range.middle) element.isBig = true
        } else {
          let summ = 0
          element.works.forEach(el => summ += el.count)
          if (summ > this.lists.maximums.big) this.lists.maximums.big = Math.ceil(summ / 5) * 5
        }
      }

      // Сортируем сначала мелкие, потом большие
      this.lists.data = this.lists.data.sort((a, b) => {
        return (a.isBig === b.isBig)? 0 : a.isBig? 1 : -1;
      });

      // Разрешаем построение графиков
      this.allowed = true
    },
    checkBiggity: function (data) {
      let big = false
      for (let element of data) {
        if (element['Неисправности'] > this.range.middle) big = true
      }
      return big
    },
    generateTypes: function (data) {
      let array = []
      for (let type of this.types) {
        array.push({
          name: type,
          count: 0
        })
      }
      for (let element of data) {
        let position = array.find(el => el.name === element['ПодсистемаПРЕДСТАВЛЕНИЕ'])
        if (position) {
          position.count = element['Неисправности']
        }
      }
      return array
    },
  }
}
</script>